import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import { DurationFormat } from '@formatjs/intl-durationformat';

/**
 * Regex for parsing ISO 8601 durations.  Copied from StackOverflow with a
 * couple changes:
 *
 * - Does not support negative durations
 * - Supports time-only durations
 *
 * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
 * @see https://stackoverflow.com/a/29153059
 * @see https://stackoverflow.com/questions/14934089/convert-iso-8601-duration-with-javascript#comment88062430_29153059
 */
export var iso8601DurationRegex = /^P(?:([.,\d]+)Y)?(?:([.,\d]+)M)?(?:([.,\d]+)W)?(?:([.,\d]+)D)?(?:T(?:([.,\d]+)H)?(?:([.,\d]+)M)?(?:([.,\d]+)S)?)?/;
/**
 * Parses an ISO 8601 duration string into an object
 *
 * @see https://stackoverflow.com/a/29153059
 */
export function parseISO8601Duration(iso8601Duration) {
  var matches = iso8601Duration.match(iso8601DurationRegex);
  if (!matches) {
    throw new Error('Invalid ISO 8601 duration');
  }
  return {
    years: matches[1] === undefined ? 0 : Number(matches[1]),
    months: matches[2] === undefined ? 0 : Number(matches[2]),
    weeks: matches[3] === undefined ? 0 : Number(matches[3]),
    days: matches[4] === undefined ? 0 : Number(matches[4]),
    hours: matches[5] === undefined ? 0 : Number(matches[5]),
    minutes: matches[6] === undefined ? 0 : Number(matches[6]),
    seconds: matches[7] === undefined ? 0 : Number(matches[7])
  };
}
export function formatDurationRange(_ref) {
  var min = _ref.min,
    max = _ref.max,
    locale = _ref.locale;
  var minDuration = parseISO8601Duration(min);
  var maxDuration = parseISO8601Duration(max);
  if (min === max) {
    return new DurationFormat(locale, {
      style: 'long'
    }).format(minDuration);
  }
  var maxStr = new DurationFormat(locale, {
    style: 'long'
  }).format(maxDuration);
  if (checkSameUnit(minDuration, maxDuration) && /^\d+\s*/) {
    var minNum = minDuration[getFirstNonZeroUnit(minDuration)];
    return "".concat(minNum, "-").concat(maxStr);
  }
  var minStr = new DurationFormat(locale, {
    style: 'long'
  }).format(minDuration);
  return "".concat(minStr, " - ").concat(maxStr);
}
function getFirstNonZeroUnit(duration) {
  var keys = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds'];
  for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
    var key = _keys[_i];
    if (duration[key] > 0) {
      return key;
    }
  }
  throw new Error('No non-zero unit found');
}

/**
 * Checks if two durations are in the same unit
 *
 * Returns `false` if either duration has multiple units
 */
export function checkSameUnit(start, end) {
  var keys = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds'];
  var startUnit;
  var endUnit;
  for (var _i2 = 0, _keys2 = keys; _i2 < _keys2.length; _i2++) {
    var key = _keys2[_i2];
    if (start[key] > 0) {
      if (startUnit) {
        return false;
      }
      startUnit = key;
    }
    if (end[key] > 0) {
      if (endUnit) {
        return false;
      }
      endUnit = key;
    }
  }
  return startUnit === endUnit;
}